export default __webpack_public_path__ + "static/media/Martiyers1.9879d0bd.jpg";